import "./sidenav-items.component.scoped.sass";
import React, { useState, useEffect, useContext } from "react";
import { sideNavItems } from "src/statics/sidenav-items";
import { history } from "react-router-guard";
import { CommonService } from "src/services/common/common.service";
import { GlobalContext } from "src/store";

export const SideNavItemsComponent = () => {
  const commonService: CommonService = new CommonService();
  const [hoverIndex, setHoverIndex] = useState(999);
  const [activeIndex, setActiveIndex] = useState(999);
  const { setPaymentNav } = useContext(GlobalContext)
  const handleHover = (type: string, index: number) => {
    setHoverIndex(type === "enter" ? index : 999);
  };

  const setActiveTab = () => {
    const routeName = history.location.pathname;
    sideNavItems.forEach((item, index) => {
      const { name, title } = item;
      if (routeName.includes(name)) {
        setActiveIndex(index);
        commonService.setTitle(title);
      }
      if (routeName.includes('payment')) {
        setPaymentNav(true);
      } else {
        setPaymentNav(false);
      }
    });
  };

  const closeMenu = () => {
    const sidenav = document.querySelector(".main-nav");
    if (sidenav?.classList.contains('show')) {
      sidenav?.classList.remove('show')
    }
  }

  const navigate = (path: string) => {
    closeMenu();
    history.push(path);
  };

  useEffect(() => {
    setActiveTab();
    history.listen(() => {
      setActiveTab();
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="sidenav-items">
      {sideNavItems.map((item, index) => {
        const { path, icon, iconHover } = item;
        return (
          <div
            key={index}
            className={
              "sidenav-item " + (activeIndex === index ? "active" : "")
            }
            onMouseEnter={handleHover.bind(null, "enter", index)}
            onMouseLeave={handleHover.bind(null, "leave", index)}
            onClick={navigate.bind(null, path)}
          >
            {activeIndex === index && <div className="activator" />}
            <img
              className="nav-icon"
              alt="nav-item"
              src={
                hoverIndex === index || activeIndex === index ? icon : iconHover
              }
            />
          </div>
        );
      })}
    </div>
  );
};
